import ApiBaseModel from "@/common/models/ApiBaseModel"

export default class CategoryListModel extends ApiBaseModel {    
    categoryText: string | null | undefined;

    static from(json: string): CategoryListModel {        
        return Object.assign(new CategoryListModel(), json);
    }
}
